import React, {ReactElement, useState} from "react";
import {PasskeyConfig} from "@/shared/passkey";
import {Button, Typography, useMediaQuery, useTheme} from "@mui/material";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {PasskeyInput} from "@/shared/PasskeyInput";

export function ClaimCodeInput(props: { onVerify(claimCode: string): Promise<boolean> }): ReactElement {
  const config: PasskeyConfig = {length: 9, type: "alphanumeric_upper"};
  const [passkey, setPasskey] = useState<string>("");
  const [verifying, setVerifying] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  return <StyledBoxColumn>
    <Typography style={{textAlign: "center"}}>Enter Claim Code to claim your profile</Typography>
    <StyledBoxColumn style={{alignItems: "center"}}>
      <PasskeyInput
        size={md ? "medium" : "small"}
        unprotected
        config={config}
        onPasskeyInputChanged={passkey => {
          setError(false);
          setPasskey(passkey);
        }}
      />
    </StyledBoxColumn>
    <Button
      onClick={() => {
        setVerifying(true);
        try {
          props.onVerify(passkey).then(success => setError(!success));
        } catch (e) {
          setError(true);
        } finally {
          setVerifying(false);
        }
        setPasskey("");
      }}
      variant={"contained"}
      disabled={passkey.length !== config.length || verifying}>
      Verify
    </Button>
    {error ? <Typography variant="caption" color={"error"}>Invalid Claim Code. Please try again.</Typography>
      : null}
  </StyledBoxColumn>;
}